export default "__VITE_ASSET__BM2b_WGf__"